exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tile-debug[data-v-997610e8]{border-left:1px solid #000;border-top:1px solid #000;font-size:12px}", ""]);

// exports
